import React, {memo} from 'react';
import {Link, withRouter} from 'react-router-dom';

import {currency} from '@helpers';

import emojiLove from 'assets/images/emoji/emoji-love.svg';
import emojiHappy from 'assets/images/emoji/emoji-happy.svg';
import emojiMeh from 'assets/images/emoji/emoji-meh.svg';
import emojiSad from 'assets/images/emoji/emoji-sad.svg';
import emojiAngry from 'assets/images/emoji/emoji-angry.svg';

import {Body, CircleIcon, Content, Date, DateHolder, Emoji, IconHolder, Inner, Item,} from './style';

export const EMOJI_LIST = {
    1: {
        value: 1,
        title: 'angry',
        image: emojiAngry,
    },
    2: {
        value: 2,
        title: 'sad',
        image: emojiSad,
    },
    3: {
        value: 3,
        title: 'meh',
        image: emojiMeh,
    },
    4: {
        value: 4,
        title: 'happy',
        image: emojiHappy,
    },
    5: {
        value: 5,
        title: 'love',
        image: emojiLove,
    },
};

const FeedbackItem = ({
                          location,
                          invoiceId,
                          isToday,
                          persianDate,
                          feedbackItemViewModels,
                          config
                      }) => {
    const multiple = feedbackItemViewModels.length > 1;
    const date = persianDate.split(' ');
    const day = date[1].trim();
    const month = date[2].trim();

    const sumPrice =
        feedbackItemViewModels.reduce(
            (sum, item) => sum + item.invoiceItemPrice,
            0,
        ) || 0;

    const firstItem = feedbackItemViewModels[0];
    const emoji = firstItem.feedbackItemRate
        ? EMOJI_LIST[firstItem.feedbackItemRate]
        : null;

    const foodNames = feedbackItemViewModels.map((i) => i.foodItemName);
    return (
        <Item>
            <Link
                to={{
                    pathname: `/feedback/${invoiceId}`,
                    state: {background: location, noClose: true},
                }}
            >
                <DateHolder $isToday={isToday}>
                    <Date>
                        <span>{isToday ? 'امروز' : day}</span>
                        {!isToday && <small>{month}</small>}
                    </Date>
                </DateHolder>
                <Body $multiple={multiple}>
                    <Inner>
                        <Content>
                            <h4>{foodNames.join(' ، ').trim()}</h4>
                            {config?.showPrice && (
                                <h5>پرداختی شما: {currency(sumPrice)}</h5>
                            )}
                            {/* <h5>
								پرداختی شما:{' '}
								{ shareData.menu.showPrice ? currency(sumPrice) : '-'}
							</h5> */}
                        </Content>
                        <IconHolder>
                            {emoji ? (
                                <Emoji src={emoji.image} alt={emoji.title}/>
                            ) : (
                                <CircleIcon/>
                            )}
                        </IconHolder>
                    </Inner>
                </Body>
            </Link>
        </Item>
    );
};

const areEqual = (prev, next) =>
    prev.location.pathanme === next.location.pathanme &&
    prev.feedbackItemViewModels === next.feedbackItemViewModels;

export default withRouter(memo(FeedbackItem, areEqual));
